const pageNameKey = "machinesList";

export const machinesListEn = {
  [pageNameKey]: {
    noDataMessage: "No VPN connections available",
    statusSourceName: "Status -  Machine / Name",
    sourceType: "Source Type",
    ipAddress: "IP Address",
    machineAddress: "Machine Address",
    statusGatewayName: "Status/Gateway Name",
    STremoteSupport: "Service Remote Support",
    OTremoteSupport: "Operator Remote Support",
    gateway: "Gateway",
    machineId: "Machine ID",
  },
};

export const machinesListPtBr = {
  [pageNameKey]: {
    noDataMessage: "Nenhuma conexão com VPN disponível",
    statusSourceName: "Status - Máquina / Nome",
    sourceType: "Tipo de fonte",
    ipAddress: "Endereço IP",
    machineAddress: "Endereço da máquina",
    statusGatewayName: "Status/Nome do Gateway",
    STremoteSupport: "Suporte Remoto ao Serviço",
    OTremoteSupport: "Suporte remoto do operador",
    gateway: "Gateway",
    machineId: "ID de máquina",
  },
};

export const machinesListDe = {
  [pageNameKey]: {
    noDataMessage: "Keine VPN-Verbindungen verfügbar",
    statusSourceName: "Status - Maschine / Name",
    sourceType: "Quellentyp",
    ipAddress: "IP-Adresse",
    machineAddress: "Maschinenadresse",
    statusGatewayName: "Status/Gateway-Name",
    STremoteSupport: "Service-Fernunterstützung",
    OTremoteSupport: "Operator-Fernunterstützung",
    gateway: "Gateway",
    machineId: "Maschinen-ID",
  },
};

export const machinesListZhHans = {
  [pageNameKey]: {
    noDataMessage: "没有可用的VPN连接",
    statusSourceName: "状态 - 机器 / 名称",
    sourceType: "源类型",
    ipAddress: "IP地址",
    machineAddress: "机器地址",
    statusGatewayName: "状态/网关名称",
    STremoteSupport: "服务远程支持",
    OTremoteSupport: "操作员远程支持",
    gateway: "网关",
    machineId: "机器ID",
  },
};

export const machinesListIt = {
  [pageNameKey]: {
    noDataMessage: "Nessuna connessione VPN disponibile",
    statusSourceName: "Stato - Macchina / Nome",
    sourceType: "Tipo di macchina",
    ipAddress: "Indirizzo IP",
    machineAddress: "Indirizzo macchina",
    statusGatewayName: "Stato/Nome gateway",
    STremoteSupport: "Supporto remoto del tecnico",
    OTremoteSupport: "Supporto remoto dell'operatore",
    gateway: "Gateway",
    machineId: "ID macchina",
  },
};

export const machinesListEs = {
  [pageNameKey]: {
    noDataMessage: "No hay conexiones VPN disponibles",
    statusSourceName: "Estado - Máquina / Nombre",
    sourceType: "Tipo de fuente",
    ipAddress: "Dirección IP",
    machineAddress: "Dirección de la máquina",
    statusGatewayName: "Estado/Nombre del gateway",
    STremoteSupport: "Servicio de asistencia remota",
    OTremoteSupport: "Soporte remoto para operadores",
    gateway: "Gateway",
    machineId: "ID de máquina",
  },
};

export const machinesListNl = {
  [pageNameKey]: {
    OTremoteSupport: "Externe operatorondersteuning",
    STremoteSupport: "Externe service-ondersteuning",
    gateway: "Gateway",
    ipAddress: "IP-adres",
    machineAddress: "Machineadres",
    machineId: "Machine-ID",
    noDataMessage: "Geen VPN-verbindingen beschikbaar",
    sourceType: "Brontype",
    statusGatewayName: "Status/Gatewaynaam",
    statusSourceName: "Status - Machine / Naam",
  },
};

export const machinesListTr = {
  [pageNameKey]: {
    OTremoteSupport: "Operatör Uzaktan Desteği",
    STremoteSupport: "Servis Uzaktan Desteği",
    gateway: "Geçit",
    ipAddress: "IP Adresi",
    machineAddress: "Makine Adresi",
    machineId: "Makine Kimliği",
    noDataMessage: "VPN bağlantısı yok",
    sourceType: "Kaynak Türü",
    statusGatewayName: "Durum/Ağ Geçidi Adı",
    statusSourceName: "Durum - Makine / Ad",
  },
};
